import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCardMail = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.33398 6.66699H28.6673V25.3337H3.33398V6.66699ZM5.46732 13.5376V23.2003H26.534V13.3908L16.0104 18.797L5.46732 13.5376ZM5.46732 11.1536L15.9962 16.4059L26.534 10.9924V8.80033H5.46732V11.1536Z",
		fill: "#4284F5"
	})
});
export default SvgCardMail;
